import React, { useState } from "react";
import { Modal, Form, Input, Select, Radio, Space, InputNumber } from "antd";

const { Option } = Select;

const SinglePeriodInventoryDiscreteModal = ({ isVisible, onClose, onConfirm }) => {
const [form] = Form.useForm();
  // const [namingConvention, setNamingConvention] = useState("default");
const [rowNaming, setRowNaming] = useState('Demands');
const [mode, setmode] = useState('unit');


  const handleOk = () => {
    form.validateFields().then((values) => {
    const rowCount = values.numRows;
    
    // Generate Row Names
    let rowNames = [];
    if (rowNaming === "Demands") {
      rowNames = Array(rowCount)
        .fill()
        .map((_, i) => `Demand ${i + 1}`);
    } else if (rowNaming === "abc") {
      rowNames = Array(rowCount)
        .fill()
        .map((_, i) => String.fromCharCode(97 + i)); // a, b, c...
    } else if (rowNaming === "ABC") {
      rowNames = Array(rowCount)
        .fill()
        .map((_, i) => String.fromCharCode(65 + i)); // A, B, C...
    } else if (rowNaming === "123") {
      rowNames = Array(rowCount)
        .fill()
        .map((_, i) => `${i + 1}`);
    } else if (rowNaming === "months") {
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      rowNames = Array(rowCount).fill().map((_, i) => months[i % 12]);
    } else {
      rowNames = Array(rowCount).fill("Custom");
    }

    // Final output
    onConfirm({
      numRows: rowCount,
      rowNaming,
      rowNames,
      mode,
      demand_levels: Array(rowCount).fill(null),   // 👈 initialize demands
      probabilities: Array(rowCount).fill(null),  // 👈 initialize probabilities
    });
  });

  };

  return (
    <Modal
      title="Create data set for Decision Tables"
      visible={isVisible}
      onOk={handleOk}
      onCancel={onClose}
      width={550}
      bodyStyle={{
        maxHeight: "400px", // fixed height
        overflowY: "auto",  // vertical scroll
      }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="numRows"
          label="Number of Demands"
          rules={[{ required: true, message: "Please enter number of rows" }]}
        >
          <InputNumber min={2} style={{ width: 250 }} />
        </Form.Item>

        <Form.Item label="Row Names">
          <Radio.Group
            onChange={(e) => setRowNaming(e.target.value)}
            value={rowNaming}
          >
            <Space direction="vertical">
              <Radio value="Demands">Demand 1, Demand 2,...</Radio>
              <Radio value="abc">a, b, c, d, e,...</Radio>
              <Radio value="ABC">A, B, C, D, E,...</Radio>
              <Radio value="123">1, 2, 3, 4, 5,...</Radio>
              <Radio value="months">January, February, March,...</Radio>
              <Radio value="other">Other</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>
        <Form.Item>
          <Radio.Group
          onChange={(e) => setmode(e.target.value)}
          value={mode}
          >
            <Space direction="vertical">
              <Radio value='unit'>Revenue and cost per unit</Radio>
              <Radio value='marginal'>Marginal loss and marginal profit</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SinglePeriodInventoryDiscreteModal;
